module.exports = __webpack_public_path__ + "facturtransp.71c6cb2a04bae2055e40.png";


//////////////////
// WEBPACK FOOTER
// D:/Repositorios/FacturacionWeb/src/assets/images/backgrounds/facturtransp.png
// module id = ../../../../../src/assets/images/backgrounds/facturtransp.png
// module chunks = main